import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { getFormatedCurrency, getFormatedNumber, getWeekDayShortName, getTimeInTwentyFourHour, 
    GetSectionCustomizationOptions } from '../components/util';
import NoPropertyPhoto from '../img/no-property-photo.png';
import LazyLoad from 'react-lazy-load';
import LazyLoadResponsive from 'react-lazyload';
import '../css/propertywidget.css';
import PropertyBookmarkButton from "./propertybookmarkbutton";
import PropertyFavoriteButton from "./propertyfavoritebutton";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import PropTypes from 'prop-types';
import {ImageRewrite} from './util.js';
import BookmarkNote from '../components/bookmarknote';
import VirtualTourIcon from '../img/virtual_tour_icon.png';
import DegreeTourIcon from '../img/degree_icon.png';
import { Button, Modal} from 'react-bootstrap';
import base64 from 'base-64';
import utf8 from 'utf8';
import moment from 'moment';
import * as clientActions from 'actions/clients';
import * as profileActions from 'actions/profile';
import * as listingActions from 'actions/listings';
import '../scss/_propertywidget.scss';
import Ecommison from '../img/ecommison_icon.png';


const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");
const PropertyCardCustomizationOptions = GetSectionCustomizationOptions("PropertyCardOptions");

class PropertyCard extends React.Component {

    static propTypes = {
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        
        this.highlightMarker = this.highlightMarker.bind(this);
        this.playdownMarker = this.playdownMarker.bind(this);
        this.redirectToProperty = this.redirectToProperty.bind(this);
        this.carouselChangeHandle = this.carouselChangeHandle.bind(this);
        this.onBookmarkClicked = this.onBookmarkClicked.bind(this);
        this.createListingRemoved = this.createListingRemoved.bind(this);
        this.deleteListingRemoved = this.deleteListingRemoved.bind(this);
        this.checkBookmark = this.checkBookmark.bind(this);
        this.checkCompare = this.checkCompare.bind(this);
        this.checkRemoved = this.checkRemoved.bind(this);
        this.onFavoriteClicked = this.onFavoriteClicked.bind(this);        
        this.onAddCompareClicked = this.onAddCompareClicked.bind(this);

        this.state = {
            fetchingResult: this.props.fetchingResult || false,
            pageUpdatedOn: this.props.pageUpdatedOn || new Date(),
            showHouseDetail: true,
            carouselIndex: 0,
            isIBProcessing: false,
            isBookmarked: this.checkBookmark(this.props.property, this.props.Client ? this.props.Client : this.props.selectedClient),
            isCompared: this.checkCompare(this.props.property.Id),
            isRemoved: this.checkRemoved(this.props.property.Id),
            isFavorite: this.checkFavorite(this.props.property, this.props.Client ? this.props.Client : this.props.selectedClient),
            isIFProcessing: false,
            isFeatured: (this.props.property) ? this.props.property.isFeatured : false,
        };
        
        this.onBookmarkNoteClosed = this.onBookmarkNoteClosed.bind(this);
        this.onBookmarkNoteSaved = this.onBookmarkNoteSaved.bind(this);

        this.goToLogin = this.goToLogin.bind(this);
        this.alertForLogin = this.alertForLogin.bind(this);
    }

    componentDidMount() {
        
    }

    highlightMarker() {
        if (this.props.property && this.props.highlightMarker) {
            this.props.highlightMarker(this.props.property);
        }
    }

    playdownMarker() {
        this.setState({showHouseDetail: true});
    }    

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props.Client) !== JSON.stringify(nextProps.Client)) {
            this.setState({
                isBookmarked: this.checkBookmark(nextProps.property, nextProps.Client, nextProps.bookmarks),
                isFavorite: this.checkFavorite(nextProps.property, nextProps.Client, nextProps.favorites)
            });                    
        }
        else if (JSON.stringify(this.props.selectedClient) !== JSON.stringify(nextProps.selectedClient)) {
            this.setState({
                isBookmarked: this.checkBookmark(nextProps.property, nextProps.Client, nextProps.bookmarks),
                isFavorite: this.checkFavorite(nextProps.property, nextProps.Client, nextProps.favorites)
            });
        }
        else if (JSON.stringify(this.props.property) !== JSON.stringify(nextProps.property)) {        
            this.setState({
                isBookmarked: this.checkBookmark(nextProps.property, this.props.Client ? this.props.Client : this.props.selectedClient, nextProps.bookmarks),
                isFavorite: this.checkFavorite(nextProps.property, this.props.Client ? this.props.Client : this.props.selectedClient, nextProps.favorites),
                isCompared: this.checkCompare(nextProps.property.Id, nextProps),
                isRemoved: this.checkRemoved(nextProps.property.Id, nextProps),
                carouselIndex: 0
            });
        }
        // this occurs if user removes compare listing from modal window
        else if (this.props.compare && JSON.stringify(this.props.compare) !== JSON.stringify(nextProps.compare)) {        
            this.setState({
                isCompared: this.checkCompare(this.props.property.Id, nextProps)
            });
        }
        // this occurs if we change selected client
        else if (this.props.removed && JSON.stringify(this.props.removed) !== JSON.stringify(nextProps.removed)) {        
            this.setState({
                isRemoved: this.checkRemoved(this.props.property.Id, nextProps)
            });
        }
        else if (this.props.favorites && JSON.stringify(this.props.favorites) !== JSON.stringify(nextProps.favorites)) {        
            this.setState({
                isFavorite: this.checkFavorite(nextProps.property, this.props.Client ? this.props.Client : this.props.selectedClient, nextProps.favorites)
            });
        }
        else if (this.props.bookmarks && JSON.stringify(this.props.bookmarks) !== JSON.stringify(nextProps.bookmarks)) {        
            this.setState({
                isBookmarked: this.checkBookmark(nextProps.property, this.props.Client ? this.props.Client : this.props.selectedClient, nextProps.bookmarks)
            });
        }
    }

    redirectToProperty(){
        var redirectUrl = (this.props.property && this.props.property.Id) ? ('/propertydetail/' + this.props.property.Id + '/' + (this.props.property.SA ? this.props.property.SA.split(' ').join('-') : this.props.property.MN) + (this.props.property.CT ? '_' + this.props.property.CT.split(' ').join('-') : '') + (this.props.property.ST ? '_' + this.props.property.ST.split(' ').join('-') : '') + (this.props.property.PC ? '_' + this.props.property.PC.split(' ').join('-') : '')) : ('');
        this.props.history.push(redirectUrl);
    }

    carouselChangeHandle(index, element){
        if(index !== null && index !== undefined) {
            this.setState({ carouselIndex: index});
        }
        this.setState({showHouseDetail: false});
        window.scrollBy(0, 2);
        window.scrollBy(0, -1);
    }

    getCarouselDetail(carouselItems)
    {
        var carouselDetail = carouselItems;
        
            if(carouselItems !== null && carouselItems.length > 1) {
                carouselDetail =  <Carousel
                showThumbs={false}
                showIndicators={false}
                swipeable={true}
                showArrows={true}
                infiniteLoop={true}
                showStatus={false}
                selectedItem={this.state.carouselIndex}
                onChange={this.carouselChangeHandle}>
                {carouselItems}
            </Carousel>;
            }
            window.carouselDetail = carouselDetail;
            return carouselDetail;
    }

    checkBookmark(property, selectedClient, nextPropBooks){
        var savedAndPendingIds = "";
        if (property && property.Id && nextPropBooks) {
            savedAndPendingIds = nextPropBooks.ids;
            if (this.props.fromSearchPage)
                savedAndPendingIds = [...this.props.bookmarkedItems, ...nextPropBooks.ids];
            return savedAndPendingIds.indexOf(property.Id) >= 0;
        }
        else if (property && property.Id && this.props.bookmarks) {
            savedAndPendingIds = this.props.bookmarks.ids;
            if (this.props.fromSearchPage)
                savedAndPendingIds = [...this.props.bookmarkedItems, ...this.props.bookmarks.ids];
            return savedAndPendingIds.indexOf(property.Id) >= 0;
        }

        return false;
    }

    checkExists(property, list){
        if(property && property.Id && this.props.fromSearchPage && list && list.length > 0)
        {
            const iBF = list.filter(p => p === property.Id);
            if(iBF && iBF.length > 0 && iBF[0] === property.Id){
                return true;
            } 
        }
    
        return false;
    }

    onBookmarkClicked(flag) {
        var self = this;
        const { audience, selectedClient, Client, property } = this.props;
        if (audience && audience.type === "agent") {
            if (Client || selectedClient) {
                if (self.props.fromSearchPage) {
                   // if property not in listing entities add it 
                    if (!self.props.listings[self.props.property.Id])
                        self.props.listingActions.addListingToEntities(self.props.property)
                    if (flag) {
                        self.setState({ isBookmarked: flag }, function () {
                            self.props.onBookmarkClicked(self.props.property, flag);
                        });
                    }
                    else {
                        if (self.checkExists(self.props.property, self.props.bookmarkedItems)) {
                            self.setState({ isBookmarked: flag }, function () {
                                self.props.onBookmarkClicked(self.props.property, flag);
                            });
                        }
                        else 
                            this.deleteBookmark(property.Id)
                    }
                }
                else {
                    if (flag) {
                        var bookmarkItems = self.state.bookmarkItems ? self.state.bookmarkItems : [];
                        if (bookmarkItems.indexOf(self.props.property.Id) < 0) {
                            bookmarkItems.push(self.props.property.Id);
                        }
                        self.setState({ bookmarkItems: bookmarkItems, openBookmarkNote: true });
                    }
                    else 
                        this.deleteBookmark(property.Id)
                }
            }
            else {
                if (this.props.showNotification) {
                    this.props.showNotification(
                        "info", "",
                        "Please select client from top menu to bookmark property", 5000
                    );
                }
            }
        }
        else 
            this.deleteBookmark(property.Id)
    }

    deleteBookmark(listingId) {
        const { selectedClient } = this.props;
        this.props.clientActions.addDeleteBookmark('DELETE', [listingId],
            selectedClient ? selectedClient.Id : 0);
        this.props.listingActions.removeListing('bookmarks', listingId);
    }

    checkFavorite(property, selectedClient, nextPropFavs){
        if (property && property.Id && nextPropFavs) 
            return nextPropFavs.ids.indexOf(property.Id) >= 0;
        else if (property && property.Id && this.props.favorites) 
            return this.props.favorites.ids.indexOf(property.Id) >= 0;

        return false;
    }

    onFavoriteClicked(isFavorite) {
        const { selectedClient, property } = this.props;
        if (this.state.isRemoved && isFavorite) {
            this.props.clientActions.addDeleteFavorite('POST', [property.Id], 
                selectedClient ? selectedClient.Id: 0);
            this.deleteListingRemoved();
            this.props.listingActions.addListing('favorites', property.Id);
        }
        else {
            this.props.clientActions.addDeleteFavorite(isFavorite ? "POST" : "DELETE", [property.Id], 
                selectedClient ? selectedClient.Id: 0);
            if (isFavorite)
                this.props.listingActions.addListing('favorites', property.Id);
            else
                this.props.listingActions.removeListing('favorites', property.Id);

            if (!this.props.listings[property.Id])
                this.props.listingActions.addListingToEntities(property)
        }
    }

    onAddCompareClicked(listingId){
        if (this.props.compare && this.props.compare.ids.length === 5 && !this.state.isCompared)
            this.props.showNotification('error', '', 'You can only select a maximum of 5 properties to compare');
        else
        {
            if (this.state.isCompared) {
                this.setState({ isCompared: false });
                this.props.listingActions.removeListing('compare', listingId);
            }
            else {
                var listing = {}
                if (this.props.property) 
                    listing = this.props.property; 
                this.setState({ isCompared: true });
                this.props.listingActions.addListing('compare', listingId, listing);
            }
        }
    }

    checkCompare(listingId, nextProps) {
        if (nextProps) {
           if (nextProps.compare && nextProps.compare.ids.indexOf(listingId) >= 0)
                return true;
            else
                return false;
        }  
        else if (this.props.compare && this.props.compare.ids.indexOf(listingId) >= 0)
            return true;
        else
            return false;
    }

    checkRemoved(listingId, nextProps) {
        if (nextProps)
            return (nextProps.removed && nextProps.removed.ids.indexOf(listingId) >= 0)
        else
            return (this.props.removed && this.props.removed.ids.indexOf(listingId) >= 0)
    }

    onBookmarkNoteClosed() {
        this.setState({openBookmarkNote: false});
    }

    onBookmarkNoteSaved(Note, SendEmail)
    {
        var bookmarkRequest = {};
        bookmarkRequest.ListingIds = this.state.bookmarkItems;
        bookmarkRequest.Note = Note;
        bookmarkRequest.SendEmail = SendEmail;

        const { selectedClient } = this.props;
        if (this.state.isRemoved) {
            this.props.clientActions.addDeleteBookmark('POST', bookmarkRequest, 
                selectedClient ? selectedClient.Id: 0);
            this.deleteListingRemoved();
        }
        else {
            this.props.clientActions.addDeleteBookmark('POST', bookmarkRequest, 
                selectedClient ? selectedClient.Id: 0);
            bookmarkRequest.ListingIds.forEach(id => {
                this.props.listingActions.addListing('bookmarks', id);
            })
        }
        this.onBookmarkNoteClosed();
    }
    
    createListingRemoved() {
        var self = this;
        const { selectedClient, property, isAnonymous } = this.props;
        
        if(isAnonymous) {
            if(this.props.showNotification) {
                this.props.showNotification(
                    "info",
                    "",
                    'You need to login to use this feature',
                    5000,
                    "Cancel",
                    null,
                    null,
                    "Login",
                    this.goToLogin
                );
            }
        }
        else {
        
            const { isFavorite, isBookmarked } = this.state;

            if (window.sessionStorage.getItem("APIAudience") === 'agents/' &&
                typeof selectedClient === "undefined") {
                    if(this.props.showNotification) {
                        this.props.showNotification( "info", "",
                            'Please select a client from the menu to remove a listing', 5000);
                    }
                    return;
            }
            // for search
            if (self.props.onListingRemoved)
                self.props.onListingRemoved(self.props.property);

            // update landing page 
            if(this.props.audience && this.props.audience.type === "agent"){
                this.props.listingActions.removeListing('recent', property.Id);    
                this.props.listingActions.removeListing('openhouse', property.Id); 
            }
            else 
                this.props.listingActions.removeListing('matching', property.Id);

            // if favorite remove it
            if (isFavorite) {
                self.props.clientActions.addDeleteFavorite('DELETE', [property.Id],
                    selectedClient ? selectedClient.Id : 0);
                self.props.listingActions.removeListing('favorites', property.Id);
            }
            // if bookmarked remove it
            if (isBookmarked) {
                self.props.clientActions.addDeleteBookmark('DELETE', [property.Id],
                    selectedClient ? selectedClient.Id : 0);
                self.props.listingActions.removeListing('bookmarks', property.Id);
            }
            // update removed and add to entities if not in
            this.props.listingActions.addListing('removed', property.Id);
            if (!self.props.listings[property.Id])
                self.props.listingActions.addListingToEntities(property)

            // API call
            this.props.clientActions.addDeleteRemove('POST', property.Id,
                selectedClient ? selectedClient.Id : 0)

        }
    }

    deleteListingRemoved() {
        const { selectedClient, audience, property, isAnonymous } = this.props;

        if(isAnonymous) {
            if(this.props.showNotification) {
                this.props.showNotification(
                    "info",
                    "",
                    'You need to login to use this feature',
                    5000,
                    "Cancel",
                    null,
                    null,
                    "Login",
                    this.goToLogin
                );
            }
        }
        else {

            var requestBody = {
                ListingId: property.Id
            }
            if (window.sessionStorage.getItem("APIAudience") === 'agents/') {
                if (selectedClient !== undefined && selectedClient !== null) {
                    requestBody.ClientId = selectedClient.Id;
                }
            }
            else {
                if (audience.Id) 
                    requestBody.ClientId = audience.Id;
            }
            this.props.listingActions.removeListing('removed', property.Id);
            this.props.clientActions.addDeleteRemove('DELETE', requestBody, 
                selectedClient ? selectedClient.Id : 0)

        }
    }

    goToLogin(){
        if(window.location.pathname !== '/' && window.location.pathname !== '/profile'){
            window.sessionStorage.setItem("RedirectLocation",base64.encode(utf8.encode(window.location.pathname)));
        }
        this.props.history.push('/login');
    }

    goToDetail = () => {
        this.props.history.push((this.props.purlPrefix && this.props.purlPrefix.url ? this.props.purlPrefix.url : '') + '/propertydetail/' + this.props.property.Id + '/' + (this.props.property.SA ? this.props.property.SA.split(' ').join('-') : this.props.property.MN) + (this.props.property.CT ? '_' + this.props.property.CT.split(' ').join('-') : '') + (this.props.property.ST ? '_' + this.props.property.ST.split(' ').join('-') : '') + (this.props.property.PC ? '_' + this.props.property.PC.split(' ').join('-') : ''));
    }

    alertForLogin(){
        const { isAnonymous } = this.props;

        if(isAnonymous) {
            if(this.props.showNotification) {
                this.props.showNotification(
                    "info",
                    "",
                    'You need to login to use this feature',
                    5000,
                    "Cancel",
                    null,
                    null,
                    "Login",
                    this.goToLogin
                );
            }
        }
    }

    showDroneModal = () => {

        if(this.props.property && this.props.property.AEDRV && this.props.property.AEDRV !== ""){
            
            var aUrl = this.props.property.AEDRV;

            if((aUrl.indexOf("//youtu") > -1 || aUrl.indexOf("//www.youtu") > -1) && aUrl.lastIndexOf('/') > -1){
                
                aUrl = aUrl.substring(aUrl.lastIndexOf('/') + 1);                

                if(aUrl && aUrl !== ""){
                    aUrl = aUrl.replace("watch?v=","");
                    aUrl = aUrl.replace("&feature=youtu.be","");
                    //aUrl = "https://www.youtube.com/embed/" + aUrl;
                    aUrl = `https://www.youtube.com/embed/${aUrl}?version=3&loop=1&playlist=${aUrl}`;
                }
            }
            else if(aUrl.indexOf("my.matterport.com") > -1 && aUrl.indexOf("&lp=") === -1){
                aUrl = aUrl + "&lp=1";
            }

            var height = window.innerHeight;
            if(height > 150) height = height - 150;
            height = parseInt((height * 90 / 100),10);

            return (
                <Modal dialogClassName="custom-full-modal" show={this.state.showDroneModal}>
                    <Modal.Body>
                        <div>
                            <iframe title="ArialView" width="100%" height={height} src={aUrl} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="row tru-headings">
                            <div className="col-md-9 text-left">
                                <div>
                                    <span className="mg-rt-10"><h2>{this.props.property.SA}</h2></span>
                                    <h4>{`${this.props.property.CT}, ${this.props.property.ST}, ${this.props.property.PC}`}</h4>
                                </div>
                                <div>
                                    {this.props.property.BD && <span>{this.props.property.BD + ' Beds'}</span>}
                                    {this.props.property.BDI && <span className="mg-lt-5 mg-rt-5">|</span>}
                                    {this.props.property.BDI && <span>{this.props.property.BDI.toString().replace('.1','.5') + ' Baths'}</span>}
                                    {this.props.property.LA && <span className="mg-lt-5 mg-rt-5">|</span>}
                                    {this.props.property.LA && <span>{getFormatedNumber(this.props.property.LA) + ' Sq.Ft.'}</span>}
                                    {this.props.property.LP && <span className="mg-lt-5 mg-rt-5">|</span>}
                                    {this.props.property.LP && <span>{getFormatedCurrency(this.props.property.LP)}</span>}
                                    <span className="mg-lt-5 mg-rt-5">|</span>
                                    <span>MLS# {this.props.property.MN}</span>
                                    {this.props.property.OH && this.props.property.OH.length > 0 &&
                                        <span className="mg-lt-5 mg-rt-5">|</span>
                                    }
                                    {this.props.property.OH && this.props.property.OH.length > 0 &&
                                        <span>{this.getFullFormatedOpenHouseDates()}</span>
                                    }
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="client_mg_btn">                                    
                                    <Button className="comn_button" onClick={() => this.setState({ showDroneModal: false })} style={{float: "right"}}>Close</Button>
                                    <Button className="comn_button" onClick={this.goToDetail} style={{float: "right"}}>Detail</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            )
        }

        return null;
    }

    show360Modal = () => {

        if(this.props.property && ((this.props.property.VTU && this.props.property.VTU !== "") ||
        (this.props.property.VT3D && this.props.property.VT3D !== ""))){
            
            var aUrl = this.props.property.VT3D;
            if(!aUrl || aUrl === "") aUrl = this.props.property.VTU;

            if((aUrl.indexOf("//youtu") > -1 || aUrl.indexOf("//www.youtu") > -1) && aUrl.lastIndexOf('/') > -1){
                
                aUrl = aUrl.substring(aUrl.lastIndexOf('/') + 1);                

                if(aUrl && aUrl !== ""){
                    aUrl = aUrl.replace("watch?v=","");
                    aUrl = aUrl.replace("&feature=youtu.be","");
                    //aUrl = "https://www.youtube.com/embed/" + aUrl;
                    aUrl = `https://www.youtube.com/embed/${aUrl}?version=3&loop=1&playlist=${aUrl}`;
                }
            }
            else if(aUrl.indexOf("my.matterport.com") > -1 && aUrl.indexOf("&lp=") === -1){
                aUrl = aUrl + "&lp=1";
            }

            var height = window.innerHeight;
            if(height > 150) height = height - 150;
            height = parseInt((height * 90 / 100),10);

            return (
                <Modal dialogClassName="custom-full-modal" show={this.state.show360Modal}>
                    <Modal.Body>
                        <div>
                            <iframe title="ArialView" width="100%" height={height} src={aUrl} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="row tru-headings">
                            <div className="col-md-9 text-left">
                                <div>
                                    <span className="mg-rt-10"><h2>{this.props.property.SA}</h2></span>
                                    <h4>{`${this.props.property.CT}, ${this.props.property.ST}, ${this.props.property.PC}`}</h4>
                                </div>
                                <div>
                                    {this.props.property.BD && <span>{this.props.property.BD + ' Beds'}</span>}
                                    {this.props.property.BDI && <span className="mg-lt-5 mg-rt-5">|</span>}
                                    {this.props.property.BDI && <span>{this.props.property.BDI.toString().replace('.1','.5') + ' Baths'}</span>}
                                    {this.props.property.LA && <span className="mg-lt-5 mg-rt-5">|</span>}
                                    {this.props.property.LA && <span>{getFormatedNumber(this.props.property.LA) + ' Sq.Ft.'}</span>}
                                    {this.props.property.LP && <span className="mg-lt-5 mg-rt-5">|</span>}
                                    {this.props.property.LP && <span>{getFormatedCurrency(this.props.property.LP)}</span>}
                                    <span className="mg-lt-5 mg-rt-5">|</span>
                                    <span>MLS# {this.props.property.MN}</span>
                                    {this.props.property.OH && this.props.property.OH.length > 0 &&
                                        <span className="mg-lt-5 mg-rt-5">|</span>
                                    }
                                    {this.props.property.OH && this.props.property.OH.length > 0 &&
                                        <span>{this.getFullFormatedOpenHouseDates()}</span>
                                    }
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="client_mg_btn">                                    
                                    <Button className="comn_button" onClick={() => this.setState({ show360Modal: false })} style={{float: "right"}}>Close</Button>
                                    <Button className="comn_button" onClick={this.goToDetail} style={{float: "right"}}>Detail</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            )
        }

        return null;
    }

    getFullFormatedOpenHouseDates = () => {
        var fOpenHouseDetail = "";
        if(this.props.property.OH && this.props.property.OH.length > 0 && 
            this.props.property.OH[0].FromDate && this.props.property.OH[0].ToDate){
            
            var dtFrom1 = moment(this.props.property.OH[0].FromDate).toDate();
            var dtTo1 = moment(this.props.property.OH[0].ToDate).toDate();

            if(CommonCustomizationOptions && CommonCustomizationOptions.ConvertOpenHouseDateFromUTCToLocal){
                dtFrom1 = moment.utc(this.props.property.OH[0].FromDate).local().toDate();
                dtTo1 = moment.utc(this.props.property.OH[0].ToDate).local().toDate();
            }

            if(this.props.property.OH.length > 1 && this.props.property.OH[1].FromDate && this.props.property.OH[1].ToDate){
                
                var dtFrom2 = moment(this.props.property.OH[1].FromDate).toDate();
                var dtTo2 = moment(this.props.property.OH[1].ToDate).toDate();

                if(CommonCustomizationOptions && CommonCustomizationOptions.ConvertOpenHouseDateFromUTCToLocal){
                    dtFrom2 = moment.utc(this.props.property.OH[1].FromDate).local().toDate();
                    dtTo2 = moment.utc(this.props.property.OH[1].ToDate).local().toDate();
                }

                if(dtFrom1.getHours() === dtFrom2.getHours() && dtFrom1.getMinutes() === dtFrom2.getMinutes()){                    
                    fOpenHouseDetail = "Open " + getWeekDayShortName(dtFrom1.getDay());
                    fOpenHouseDetail = fOpenHouseDetail + " & " + getWeekDayShortName(dtFrom2.getDay());
                    fOpenHouseDetail = fOpenHouseDetail + " " + getTimeInTwentyFourHour(dtFrom1.getHours(), dtFrom1.getMinutes());
                    fOpenHouseDetail = fOpenHouseDetail + " - " + getTimeInTwentyFourHour(dtTo1.getHours(), dtTo1.getMinutes());
                }
                else {                    
                    fOpenHouseDetail = "Open " + getWeekDayShortName(dtFrom1.getDay());
                    fOpenHouseDetail = fOpenHouseDetail + " " + getTimeInTwentyFourHour(dtFrom1.getHours(), dtFrom1.getMinutes());
                    fOpenHouseDetail = fOpenHouseDetail + " - " + getTimeInTwentyFourHour(dtTo1.getHours(), dtTo1.getMinutes());
                    fOpenHouseDetail = fOpenHouseDetail + " & " + getWeekDayShortName(dtFrom2.getDay());
                    fOpenHouseDetail = fOpenHouseDetail + " " + getTimeInTwentyFourHour(dtFrom2.getHours(), dtFrom2.getMinutes());
                    fOpenHouseDetail = fOpenHouseDetail + " - " + getTimeInTwentyFourHour(dtTo2.getHours(), dtTo2.getMinutes());
                }
            }
            else{
                fOpenHouseDetail = "Open " + getWeekDayShortName(dtFrom1.getDay());
                fOpenHouseDetail = fOpenHouseDetail + " " + getTimeInTwentyFourHour(dtFrom1.getHours(), dtFrom1.getMinutes());
                fOpenHouseDetail = fOpenHouseDetail + " - " + getTimeInTwentyFourHour(dtTo1.getHours(), dtTo1.getMinutes());
            }
        }

        return fOpenHouseDetail;
    }

    getShortFormatedOpenHouseDays = () => {
        var sOpenHouseDetail = "";
        if(this.props.property.OH && this.props.property.OH.length > 0 && this.props.property.OH[0].FromDate){
            
            var dtFrom1 = moment(this.props.property.OH[0].FromDate).toDate();

            if(CommonCustomizationOptions && CommonCustomizationOptions.ConvertOpenHouseDateFromUTCToLocal){
                dtFrom1 = moment.utc(this.props.property.OH[0].FromDate).local().toDate();
            }

            if(this.props.property.OH.length > 1){
                
                var dtFrom2 = moment(this.props.property.OH[1].FromDate).toDate();

                if(CommonCustomizationOptions && CommonCustomizationOptions.ConvertOpenHouseDateFromUTCToLocal){
                    dtFrom2 = moment.utc(this.props.property.OH[1].FromDate).local().toDate();
                }

                sOpenHouseDetail = getWeekDayShortName(dtFrom1.getDay());
                sOpenHouseDetail = sOpenHouseDetail + " & " + getWeekDayShortName(dtFrom2.getDay());
            }
            else{
                sOpenHouseDetail = getWeekDayShortName(dtFrom1.getDay());
            }
        }

        return sOpenHouseDetail;
    }

    render() {
        
        var isExternal = false;
        if(this.props.property && this.props.property.Id === 0){
            isExternal = true;
        }

        var hasURL = false;
        if(this.props.property && this.props.property.URL && this.props.property.URL !== ""){
            hasURL = true;
        }

        var purlPrefixUrl = this.props.purlPrefix && this.props.purlPrefix.url ? this.props.purlPrefix.url : '';
        var propertyDetailUrl = purlPrefixUrl + 
            '/propertydetail/' + this.props.property.Id + '/' + 
            (this.props.property.SA ? this.props.property.SA.split(' ').join('-') : this.props.property.MN) + 
            (this.props.property.CT ? '_' + this.props.property.CT.split(' ').join('-') : '') + 
            (this.props.property.ST ? '_' + this.props.property.ST.split(' ').join('-') : '') + 
            (this.props.property.PC ? '_' + this.props.property.PC.split(' ').join('-') : '');

        var propertyDetailUrlStyle = {
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "0",
            left: "0"
        }

        var tourUrl = null;
        var aViewUrl = null;
        if(this.props.property && this.props.property.AEDRV && this.props.property.AEDRV !== ""){
            aViewUrl =  this.props.property.AEDRV;
        }
        if(this.props.property && this.props.property.VT3D && this.props.property.VT3D !== ""){
            tourUrl =  this.props.property.VT3D;
        }
        else if(this.props.property && this.props.property.VTU && this.props.property.VTU !== ""){
            tourUrl =  this.props.property.VTU;
        }      
        
        var imgTitle = "";
        if (this.props.property) {
            imgTitle = this.props.property.SA + ', ' + this.props.property.CT + ', ' + this.props.property.ST + ', ' + this.props.property.PC;
        }

        var carouselItems;
        var self = this;
        if (this.props.property && !this.props.property.isFBY && this.props.property.Photos && this.props.property.Photos.length > 0) {
            carouselItems = this.props.property.Photos.map(function (photo, i) {
                if (i === 0) {
                    return (
                        <div key={i}>
                            {(!hasURL && !self.props.property.isFBY) ?
                            <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                                <img src={ImageRewrite(photo, true)} alt={imgTitle} />
                            </Link> :
                            <img src={ImageRewrite(photo, true)} alt={imgTitle} />
                            }
                        </div>
                    );
                } else {
                return (
                    <div key={i}>
                        {window.innerWidth < 768 ?
                            <LazyLoadResponsive height={183} once>
                                {(!hasURL && !self.props.property.isFBY) ?
                                <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                                    <img src={ImageRewrite(photo, true)} alt={imgTitle} />
                                </Link> :
                                <img src={ImageRewrite(photo, true)} alt={imgTitle} />
                                }
                            </LazyLoadResponsive> :
                            <LazyLoad>
                                {(!hasURL && !self.props.property.isFBY) ?
                                    <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                                        <img src={ImageRewrite(photo, true)} alt={imgTitle} />
                                    </Link> :
                                    <img src={ImageRewrite(photo, true)} alt={imgTitle} />
                                }
                            </LazyLoad>
                        }                        
                    </div>
                );
                }
            });
        }
        else if (this.props.property && this.props.property.isFBY && this.props.property.Photo && this.props.property.Photo !== "") {
            carouselItems = (
                <div key={"bfyphoto"}>
                    <img src={ImageRewrite(this.props.property.Photo, true)} alt="" />
                </div>
            );
        } else {
            carouselItems =
                <div>
                    {(!hasURL && !self.props.property.isFBY) ?
                        <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                            <img src={NoPropertyPhoto} alt={imgTitle} />
                        </Link> : <img src={NoPropertyPhoto} alt={imgTitle} />
                    }
                </div>;
        }

        // If we are searching by image type and no image exists for that type we display the first image and display a 'No Photo Match' 
        var noPhotoOverlay = null;
        if (this.props.imageType && this.props.imageType !== "" && this.props.imageType.toLowerCase() !== "all") {
            if (!this.props.property.INDXRMSG ||
                (this.props.property.INDXRMSG &&
                    (this.props.property.INDXRMSG === "" || this.props.property.INDXRMSG === null))) {
                imgTitle = this.props.imageType + ", " + imgTitle;
            } else {
                noPhotoOverlay = (<div className="no-photo-overlay">{this.props.property.INDXRMSG}</div>);
            }

            if (this.props.property.INDXR && this.props.property.INDXR !== '') {
                var idxImgs = this.props.property.INDXR.split('|');
                if (idxImgs && idxImgs.length > 0) {
                    carouselItems = idxImgs.map(function (imgTag, i) {
                        if (i === 0) {
                            return (
                                <div key={i}>
                                    {(!hasURL && !self.props.property.isFBY) ?
                                        <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                                            <img src={ImageRewrite(imgTag, true)} alt={imgTitle} />
                                        </Link> :
                                        <img src={ImageRewrite(imgTag, true)} alt={imgTitle} />
                                    }
                                </div>
                            );
                        } else {
                        return (
                            <div key={i}>
                                {window.innerWidth < 768 ?
                                    <LazyLoadResponsive height={183} once>
                                        {(!hasURL && !self.props.property.isFBY) ?
                                            <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                                                <img src={ImageRewrite(imgTag, true)} alt={imgTitle} />
                                            </Link> :
                                            <img src={ImageRewrite(imgTag, true)} alt={imgTitle} />
                                        }
                                    </LazyLoadResponsive> :
                                    <LazyLoad>
                                        {(!hasURL && !self.props.property.isFBY) ?
                                            <Link to={propertyDetailUrl} style={propertyDetailUrlStyle}>
                                                <img src={ImageRewrite(imgTag, true)} alt={imgTitle} />
                                            </Link> :
                                            <img src={ImageRewrite(imgTag, true)} alt={imgTitle} />
                                        }
                                    </LazyLoad>
                                }
                            </div>
                            );
                        }
                    });
                }
            }
        }       
        /* const { openhousefromdate } = this.props.searchParameters;
        var openHouseDetail = !openhousefromdate && this.props.property.OH && this.props.property.OH.length ? this.props.property.OH[0] :
            (this.props.property.OH || []).find(e => 
                new Date(new Date(openhousefromdate).toDateString()) <= new Date(new Date(e.FromDate).toDateString())); */

        var fOpenHouseDetail = this.getFullFormatedOpenHouseDates();

        var selectedClientName = "";
        if(this.props.Client) {
            selectedClientName = this.props.Client.FirstName + " " + this.props.Client.LastName;
        }
        else if(this.props.selectedClient) {
            selectedClientName = this.props.selectedClient.FirstName + " " + this.props.selectedClient.LastName;
        }

        var addrStr = "";
        var addrStr1 = "";
        if(this.props.property.SA && this.props.property.SA !== ""){
            addrStr = this.props.property.SA;
        }
        if(this.props.property.CT && this.props.property.CT !== ""){
            if(addrStr1 === "") addrStr1 = this.props.property.CT;
            else addrStr1 += ", " + this.props.property.CT;
        }
        if(this.props.property.ST && this.props.property.ST !== ""){
            if(addrStr1 === "") addrStr1 = this.props.property.ST;
            else addrStr1 += ", " + this.props.property.ST;
        }
        if(this.props.property.PC && this.props.property.PC !== ""){
            if(addrStr1 === "") addrStr1 = this.props.property.PC;
            else addrStr1 += ", " + this.props.property.PC;
        }

        var tlcVal = null;
        if(this.props.hideTLC){
            tlcVal = null;
        }
        else if(this.props.property.TLC && this.props.property.TLC !== 0 && this.props.property.TLC !== "" && this.props.property.TLC !== "0"){
            tlcVal = (<div className="card_tlc_amount">TLC: {getFormatedCurrency(this.props.property.TLC)}</div>)
        }

        var line1 = null;        
        if(this.props.property.isFBY && this.props.property.Price && this.props.property.Price !== ""){
            line1 = (
                <div className="full-width flt-left full_amount">                
                    <div className="card_prop_amount">{this.props.property.Price}</div>
                </div>
            );
        }
        else if(!this.props.property.isFBY){
            line1 = (
                <div className={tlcVal ? "full-width flt-left" : "full-width flt-left full_amount"}>
                    {(this.props.property.OLP && this.props.property.OLP !== "" && this.props.property.OLP !== "0") ?
                        <div className="card_prop_amount">{this.props.property.OLP}</div> : 
                        ((this.props.property.LP && this.props.property.LP !== "" && this.props.property.LP !== 0 && this.props.property.LP !== "0") ?
                        <div className="card_prop_amount">{getFormatedCurrency(this.props.property.LP)}</div> : null)
                    }                
                    {tlcVal}
                </div>
            );
        }

        var line2 = null;        
        if(this.props.property.isFBY){
            line2 = (
                <div className="card_prop_add mg-top-5">
                    <div className="card_add_lt no_icons">
                        {(this.props.property.Address && this.props.property.Address !== "") && 
                            <div className="address_line">{this.props.property.Address}</div>
                        }
                        {(this.props.property.Township && this.props.property.Township !== "") && 
                            <div className="address_line">{this.props.property.Township}</div>
                        }
                    </div>
                </div>
            );
        }
        else{
            line2 = (
                <div className="card_prop_add mg-top-5">
                    <div className={((!tourUrl || tourUrl === "") && (!aViewUrl || aViewUrl === "")) ? "card_add_lt no_icons" : "card_add_lt"}>
                        {addrStr && addrStr !== "" &&
                            <div className="address_line">                                
                                {(PropertyCardCustomizationOptions && PropertyCardCustomizationOptions.ShowHighlightMarkerIcon && this.props.showHighlightMarker) ?
                                    (<span onClick={this.highlightMarker}><i className="fa fa-map-marker cursor-pointer"></i></span>) : null
                                }
                                {addrStr}
                            </div>
                        }
                        {addrStr1 && addrStr1 !== "" && <div className="address_line">{addrStr1}</div>}
                    </div>
                    {(!this.props.property.isFBY && ((tourUrl && tourUrl !== "") || (aViewUrl && aViewUrl !== ""))) &&
                        <div className="card_virtual_icon">
                            {(aViewUrl && aViewUrl !== "") && 
                            ((aViewUrl.toLowerCase().indexOf("vimeo") > -1) || (aViewUrl.toLowerCase().indexOf("http:") > -1)) ?
                                (<div className="card_camera_icon cursor-pointer">
                                    <span><a href={aViewUrl} alt="" target="_blank" rel="noopener noreferrer"><img src={VirtualTourIcon} alt="" /></a></span>
                                </div>) : 
                                ((aViewUrl && aViewUrl !== "") ? 
                                    (<div className="card_camera_icon cursor-pointer">
                                        <span><img src={VirtualTourIcon} alt="" onClick={() => this.setState({ showDroneModal: true })} /></span>
                                    </div>) : null)                                
                            }
                            {(tourUrl && tourUrl !== "") &&
                            ((tourUrl.toLowerCase().indexOf("vimeo") > -1) || (tourUrl.toLowerCase().indexOf("http:") > -1)) ?
                                (<div className="card_tour_icon cursor-pointer">
                                    <span><a href={tourUrl} alt="" target="_blank" rel="noopener noreferrer"><img src={DegreeTourIcon} alt="" /></a></span>
                                </div>) : 
                                ((tourUrl && tourUrl !== "") ? 
                                    (<div className="card_tour_icon cursor-pointer">
                                        <span><img src={DegreeTourIcon} alt="" onClick={() => this.setState({ show360Modal: true })} /></span>
                                    </div>) : null)
                            }
                        </div>
                    }
                </div>
            );
        }

        var lineBB = null;
        if(this.props.property.isFBY){
            lineBB = [];            
            if(this.props.property.Phone && this.props.property.Phone !== ""){
                lineBB.push(<span key="phone">{this.props.property.Phone}</span>);
            }
        }
        else{
            lineBB = [];

            var isOther = false;
            if(this.props.property.ISCOM || this.props.property.ISLAND || this.props.property.ISMUL) isOther = true;
            if(this.props.property.ISCOM){
                lineBB.push(<span key="comm">Commercial</span>);
            }
            if(this.props.property.ISLAND){
                if(lineBB.length > 0) lineBB.push(<span key="land_sep" className="text-color-gray"> | </span>);
                lineBB.push(<span key="land">Land</span>);
            }
            if(this.props.property.ISMUL){
                if(lineBB.length > 0) lineBB.push(<span key="milt_sep" className="text-color-gray"> | </span>);
                lineBB.push(<span key="multi">Multi Unit</span>);
            }

            if(!isOther && this.props.property.BD && this.props.property.BD !== "" && this.props.property.BD !== 0 && this.props.property.BD !== "0"){
                lineBB.push(<span key="beds">{this.props.property.BD + ' Beds'}</span>);
            }
            if(!isOther && this.props.property.BDI && this.props.property.BDI !== "" && this.props.property.BDI !== 0 && this.props.property.BDI !== "0"){
                if(lineBB.length > 0) lineBB.push(<span key="baths_sep" className="text-color-gray"> | </span>);
                lineBB.push(<span key="baths">{this.props.property.BDI.toString().replace('.1','.5') + ' Baths'}</span>);
            }
            if(!isOther && !this.props.property.isFPR && !this.props.property.isFOH && !this.props.property.isFBY && !this.props.property.isFHP && this.props.property.LA && this.props.property.LA !== "" && this.props.property.LA !== 0 && this.props.property.LA !== "0"){
                if(lineBB.length > 0) lineBB.push(<span key="sqft_sep" className="text-color-gray"> | </span>);
                lineBB.push(<span key="sqft">{getFormatedNumber(this.props.property.LA) + ' Sq.Ft.'}</span>);
            }
        }
        if(lineBB && lineBB.length > 0){
            lineBB = (<div className="full-width address_line address_line_sm flt-left pd-sides-10 ft-sz-11">{lineBB}</div>);
        }

        var line4 = null;
        if(!this.props.property.isFBY && this.props.property.isFOH && this.props.property.DESC && this.props.property.DESC !== ""){
            line4 = (
                <div className="card_openhouse address_line" title={this.props.property.DESC}>
                    {this.props.property.DESC}
                </div>
            );
        }
        else if(!this.props.property.isFBY && (!this.props.property.DESC || this.props.property.DESC === "") && fOpenHouseDetail && fOpenHouseDetail !== ""){
            line4 = (
                <div className="card_openhouse address_line" title={fOpenHouseDetail}>
                    {fOpenHouseDetail}
                </div>
            );
        }
        else if(this.props.property.isFBY && 
            ((this.props.property.Builder && this.props.property.Builder !== "") || 
            (this.props.property.SalesRep && this.props.property.SalesRep))){
            line4 = (
                <div className="card_openhouse address_line">
                    {(this.props.property.Builder && this.props.property.Builder !== "") ? <span>{this.props.property.Builder}</span> : null}
                        {(this.props.property.SalesRep && this.props.property.SalesRep !== "") ? <span className="text-color-gray"> | </span> : null}
                        {(this.props.property.SalesRep && this.props.property.SalesRep !== "") ? <span>{this.props.property.SalesRep}</span> : null}
                </div>
            );
        }

        var lineListCourtesy = null;
        if(this.props.property.MN){
            lineListCourtesy = "MLS# " + this.props.property.MN
        }
        if (this.props.property.OFCNAME || this.props.property.AGTNAME) {
            if (
                this.props.property.OFCNAME &&
                this.props.property.OFCNAME !== "" &&
                this.props.property.AGTNAME &&
                this.props.property.AGTNAME !== ""
              ) {
                lineListCourtesy = (lineListCourtesy ? (lineListCourtesy + ", ") : lineListCourtesy) +  `Listing By: ${this.props.property.OFCNAME}, ${this.props.property.AGTNAME}`;
              } else if (
                this.props.property.OFCNAME &&
                this.props.property.OFCNAME !== "" &&
                (!this.props.property.AGTNAME || this.props.property.AGTNAME === "")
              ) {
                lineListCourtesy = (lineListCourtesy ? (lineListCourtesy + ", ") : lineListCourtesy) +  `Listing By: ${this.props.property.OFCNAME}`;
              } else if (
                (!this.props.property.OFCNAME || this.props.property.OFCNAME === "") &&
                this.props.property.AGTNAME &&
                this.props.property.AGTNAME !== ""
              ) {
                lineListCourtesy = (lineListCourtesy ? (lineListCourtesy + ", ") : lineListCourtesy) +  `Listing By: ${this.props.property.AGTNAME}`;
              }
        }
        if(lineListCourtesy){
            lineListCourtesy = <div className="card_listing_by address_line" title={lineListCourtesy}>{lineListCourtesy}</div>
        }
        
        var cardBody = (
            <div>
                <div className="prop_card_slider">
                    <div className="slider_img_box">
                        <div className="slider_img">
                            {this.getCarouselDetail(carouselItems)}
                            {noPhotoOverlay}
                            
                            {!this.props.hideAllButtons && !isExternal &&
                                <div className="prop_com_icon">
                                    <div className="img_info_iconbox property-item-bookmark">
                                        <div className="card_icon compare_icon tour_compare_icon" title="Compare this Home">
                                            <i className={ `icon-compare ${this.state.isCompared ? 'active': ''}`} 
                                                onClick={()=>this.onAddCompareClicked(this.props.property.Id)}></i>
                                        </div>
                                        {!this.state.isRemoved && !(this.props.audience.type === 'agent' && this.state.isFavorite) &&
                                            <div className="card_icon remove_clsoe_icon" title="Remove this Home">
                                                <i className="icon-xoutproperty"
                                                    onClick={() => this.createListingRemoved()}></i>
                                            </div>
                                        }
                                        {this.state.isRemoved &&
                                            <div className="card_icon tour-restore-icon" title="Restore this Home">
                                                <i className="fa fa-plus"
                                                    onClick={() => this.deleteListingRemoved()}></i>
                                            </div>
                                        }
                                    </div>
                                    <div className="property-left-icon">
                                        {!this.props.isAnonymous && this.props.audience && this.props.audience.type === 'agent' &&
                                            <PropertyBookmarkButton
                                            isBookmarked={this.state.isBookmarked}
                                            isIBProcessing={this.state.isIBProcessing}
                                            onBookmarkClicked={this.onBookmarkClicked} />                                     
                                        }
                                        {!this.props.isAnonymous && this.props.audience && this.props.audience.type === 'client' && this.state.isBookmarked &&
                                            <PropertyBookmarkButton
                                            isBookmarked={this.state.isBookmarked}
                                            isIBProcessing={this.state.isIBProcessing}
                                            onBookmarkClicked={this.onBookmarkClicked} />                                        
                                        }
                                        {!this.props.isAnonymous && this.props.audience && this.props.audience.type === 'client' &&
                                            <PropertyFavoriteButton
                                                property={this.props.property}
                                                onFavoriteClicked={this.onFavoriteClicked}
                                                isFavorite={this.state.isFavorite}
                                                isIFProcessing={this.state.isIFProcessing} />
                                        }
                                        {!this.props.isAnonymous && this.props.audience && this.props.audience.type === 'agent' && this.state.isFavorite &&
                                            <PropertyFavoriteButton
                                                property={this.props.property}
                                                onFavoriteClicked={null}
                                                isFavorite={this.state.isFavorite}
                                                isIFProcessing={this.state.isIFProcessing} />
                                        }
                                        {this.props.isAnonymous &&
                                            <PropertyFavoriteButton
                                                property={this.props.property}
                                                onFavoriteClicked={this.alertForLogin}
                                                isFavorite={false}
                                                isIFProcessing={false} />
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        {(!this.props.property.isFBY && hasURL) &&
                            // eslint-disable-next-line
                            <a href={this.props.property.URL} target="_blank" rel="noopener noreferrer" alt="" style={widgetClick}></a>
                        }                                
                        {(this.props.property.isFBY && hasURL) &&
                            // eslint-disable-next-line
                            <a href={this.props.property.URL} target="_blank" rel="noopener noreferrer" alt="" style={widgetClick}></a>
                        }                                
                    </div>
                </div>
                <div className="card_prop_info">
                    {line1}
                    <div className="prop_info_box">
                        <div className="prop_info_left">
                            {line2}
                            {lineBB}
                            {lineListCourtesy}
                            {line4}
                        </div>
                        {(CommonCustomizationOptions && CommonCustomizationOptions.EcommissionUrl && CommonCustomizationOptions.EcommissionUrl !== "") &&
                        <div className="prop_info_right">
                            <a href={CommonCustomizationOptions.EcommissionUrl} rel="noopener noreferrer" target="_blank" >
                                <img src={Ecommison} alt=""/>
                            </a>
                        </div>
                        }
                    </div>
                </div>
            </div>
        );

        if (this.props.LazyLoad) {
            // Lazy Load the card body if required
            if(window.innerWidth < 768){
                cardBody = <LazyLoadResponsive height={183} offset={window.innerWidth < 768 ? 250 : (window.innerWidth < 1500 ? 600 : 800)} throttle={150} overflow={window.innerWidth >= 768 ? true : false} resize once>{cardBody}</LazyLoadResponsive>
            }
            else{
                cardBody = <LazyLoad height={183} offset={200} throttle={50}>{cardBody}</LazyLoad>
            }            
        }

        return (            
            <div className={this.props.classname || "prop_card"} onMouseLeave={this.playdownMarker}>
                <div className="prop_card_box">
                      {cardBody}                
                </div>
 
                {this.state.openBookmarkNote &&
                <div>
                    <BookmarkNote 
                        onBookmarkNoteSaved={this.onBookmarkNoteSaved} 
                        onBookmarkNoteClosed={this.onBookmarkNoteClosed}
                        showDialog={true}
                        isDataFetching={this.state.isIBProcessing}
                        titleMessage={<div style={{marginBottom: "10px"}}>You've selected <span style={{fontWeight: "bold"}}>{this.state.bookmarkItems.length}</span> properties for <span style={{fontWeight: "bold"}}>{selectedClientName}</span></div>}/>
                </div>
                }
                {this.state.showDroneModal &&
                    this.showDroneModal()
                }
                {this.state.show360Modal &&
                    this.show360Modal()
                }
            </div>
        );
    }
}

const widgetClick = {
    position: 'absolute',
    top: '14%',
    width: '84%',
    height: '86%',
    left: '8%',
    // zIndex: 99,
     zIndex: 1,
    cursor: 'pointer'
}

const mapStateToProps = (state, props) => ({
    listings: state.entities.listings,
    searchParameters: state.search.parameters,
    audience: state.session.audience,
    purlPrefix: state.session.purlPrefix,
    isFetchingProfile: state.profile.isFetching,
    profile: state.profile.mine,
    selectedClient: state.entities.clients[state.clients.selectedClient],
    compare: state.listings.compare,
    removed: state.listings.removed || { ids: [] },
    favorites: state.listings.favorites || { ids: [] },
    bookmarks: state.listings.bookmarks|| { ids: [] },
    isAnonymous: state.session.isAnonymous,
});

const mapDispatchToProps = dispatch => ({
    clientActions: bindActionCreators(clientActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch),
    listingActions: bindActionCreators(listingActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertyCard);